import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import Studio from "./Studio";
import { API_URL, GLYPH_COUNT } from "../constants";

// The full icon list is loaded on demand, as on the icons page
const StudioPage = ({ icons, dispatch, location }) => {
  useEffect(() => {
    // The server preloads only the opening categories; fetch unless the full set is here
    if (icons.length >= GLYPH_COUNT) return;
    axios
      .get(API_URL + "/api/icons/all")
      .then(({ data }) => dispatch({ type: "SET_ICONS", payload: data.result }))
      .catch((error) => console.error("ico error: ", error)); // eslint-disable-line no-console
  }, []);

  return <Studio icons={icons} location={location} />;
};

StudioPage.propTypes = {
  icons: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

export default connect((store) => ({ icons: store.localstore.icons || [] }))(StudioPage);
